import { render, staticRenderFns } from "./Demografia.vue?vue&type=template&id=2a4bc32c&"
import script from "./Demografia.vue?vue&type=script&lang=js&"
export * from "./Demografia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports